import React from 'react';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import _merge from 'lodash/merge';

import { useTrackingData } from './DataProviders';


const READY_TO_GO = 'Ready to Go';
const DEFAULT_STATUS = { text: READY_TO_GO, status: 'isReadyToGo' };


const formattedDeliveryDate = ({ estimated_delivery_date }) => {
  let isToday = moment(estimated_delivery_date).isSame(moment(), 'day');

  if( isToday ) {
    return { text: 'Today' }
  }
  else {
    return { date: estimated_delivery_date }
  }
};


function messageAndStatus(source_status_code, estimated_delivery_date, hasAnyEvents) {
  source_status_code = source_status_code.toUpperCase();

  switch( source_status_code ) {
    case 'AC': {
      if( estimated_delivery_date ) {
        return { ...formattedDeliveryDate({ estimated_delivery_date }), status: 'isAccepted' };
      }
      return { text: READY_TO_GO, status: 'isAccepted' };
    }
    case 'IT': {
      if( estimated_delivery_date ) {
        return { ...formattedDeliveryDate({ estimated_delivery_date }), status: 'isInTransit' };
      }
      return { text: 'In Transit', status: 'isInTransit' };
    }
    case 'DE':
      return { text: 'Delivered', status: 'isDelivered' };
    case 'EX':
    case 'UN':
      if( estimated_delivery_date ) {
        return { ...formattedDeliveryDate({ estimated_delivery_date }), status: 'isInTransit' };
      }
      else if( hasAnyEvents ) {
        return { text: 'In Transit', status: 'isInTransit' };
      }
      else {
        return { text: 'Status Unavailable', status: 'isUnknown' };
      }
    case 'AT':
      return { text: 'We Missed You', status: 'isDeliveryAttempted' };
    default:
      return DEFAULT_STATUS;
  }
}

const useStyles = makeStyles( theme => ({
  root: {
    ..._merge( {}, theme.main, theme.estimatedDeliveryDateOrStatus ),
    '&:not(.isDelivered):not(.isInTransit):not(.estimatedDeliveryDate)': {
      color: '#929292',
      fontWeight: 'normal'
    }
  }
}));

export default function EstimatedDeliveryDateOrStatus({ className='', children }) {
  const classes = useStyles();
  const { source=null, source_status_code='', estimated_delivery_date=null, carrier_events=[] } = useTrackingData();

  const { date, text, status } = ( !source || source.toLowerCase() !== 'shipengine') ? (
    DEFAULT_STATUS
  ):(
    messageAndStatus( source_status_code, estimated_delivery_date, !!carrier_events.length )
  );

  const formattedStatusOrDate = ( date ? <>
    <span className="estimated-delivery-date__day-of-week">{moment(date).format('dddd, ')}</span>
    <span className="estimated-delivery-date__month-and-date">{moment(date).format('MMMM D')}</span>
  </> : (
    text
  ));

  return (
    <div
      className={`${classes.root} ${className} ${status}`}
      data-testid="estimated-delivery-date-or-status"
      title={date && `Estimated delivery: ${moment(date).format('dddd, MMMM D')}`}
    >
      { children ? (
        children({ date, text, status, formattedStatusOrDate })
      ):(
        formattedStatusOrDate
      )}
    </div>
  );
}